module.exports = __webpack_public_path__ + "img/93983.cc473f34.svg";